module.exports = __webpack_public_path__ + "static/img/LV.4bcf3863.png";